import React, { useEffect, useState } from 'react';
import BookingModal from '../components/BookingModal';
import GallerySlider from '../components/GallerySlider';
import LazyImage from '../components/LazyImage';

const Home: React.FC = () => {
  const [bookingModal, setBookingModal] = useState({ isOpen: false, facilityType: '' });

  const openBookingModal = (facilityType: string) => {
    setBookingModal({ isOpen: true, facilityType });
  };

  const closeBookingModal = () => {
    setBookingModal({ isOpen: false, facilityType: '' });
  };

  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);


  return (
    <main>
      {/* Slider Area */}
      <section id="home" className="slider-area fix p-relative">
        <div className="slider-active">
          <div className="single-slider slider-bg d-flex align-items-center">
            <video width="100%" autoPlay loop muted>
              <source src="/images/video/VIDEO-2023-02-18-12-17-57.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </section>

      {/* About Area */}
      <section className="about-area about-p pt-70 pb-70 p-relative fix" style={{backgroundImage: 'url(/images/bg-1.jpg)', backgroundSize: 'cover'}}>
        <div className="animations-02"><img src="/img/bg/an-img-02.png" alt="contact-bg-an-02" /></div>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="s-about-img p-relative wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s" style={{position: 'relative'}}>
                <div style={{
                  position: 'relative',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(212, 175, 55, 0.3)',
                  border: '3px solid rgba(212, 175, 55, 0.4)'
                }}>
                  <LazyImage src="/images/Slide_Gallery/0G5A2845.JPG" alt="Bangtan Lounge Interior" style={{width: '100%', height: 'auto', display: 'block'}} />
                </div>
                <div className="about-icon" style={{
                  position: 'absolute',
                  bottom: '-30px',
                  right: '-30px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 15px 40px rgba(212, 175, 55, 0.4)',
                  border: '3px solid rgba(212, 175, 55, 0.4)',
                  width: '280px',
                  height: '280px'
                }}>
                  <LazyImage src="/images/Slide_Gallery/0G5A2849.JPG" alt="Bangtan Lounge DJ" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="about-content s-about-content wow fadeInRight animated pl-30" data-animation="fadeInRight" data-delay=".4s">
                <div className="about-title second-title pb-25">
                  <h5 style={{color: '#d4af37', fontSize: '1.1rem', fontWeight: '600', marginBottom: '15px'}}>WELCOME TO BANGTAN</h5>
                  <h2 style={{fontSize: '2.8rem', fontWeight: '800', lineHeight: '1.3', marginBottom: '20px'}}>Welcome to Bangtan Lounge - Global Eatery & Bar</h2>
                  <p style={{fontSize: '1.1rem', color: '#d4af37', fontWeight: '600', marginBottom: '15px'}}>🎵 Where Great Food and Great Drinks Meet 🎵</p>
                </div>
                <p style={{textAlign: 'justify', fontSize: '1rem', lineHeight: '1.8', marginBottom: '15px', color: '#e0e0e0'}}>
                  Located in the heart of Mira Bhayandar, Bangtan Lounge is your ultimate destination for electrifying music, unforgettable parties, and mouth-watering global cuisine. Whether you are looking to chill with friends or celebrate big, we've got the perfect vibe, beats, and bites to make every moment epic.
                </p>
                <div style={{backgroundColor: 'rgba(212, 175, 55, 0.1)', padding: '15px', borderLeft: '4px solid #d4af37', marginBottom: '15px', borderRadius: '4px'}}>
                  <p style={{textAlign: 'justify', fontSize: '0.95rem', lineHeight: '1.7', margin: '0', color: '#e0e0e0'}}>
                    <strong style={{color: '#d4af37'}}>🍽️ Best Restro & Bar in Mira Road:</strong> Searching for restaurants in Mira Road East? Bangtan Lounge offers premium dining with global cuisine, craft cocktails, and an electrifying atmosphere.
                  </p>
                </div>
                <p style={{textAlign: 'justify', fontSize: '1rem', lineHeight: '1.8', marginBottom: '20px', color: '#e0e0e0'}}>
                  <strong style={{color: '#d4af37'}}>Great Food. Killer Music. Pure Vibes.</strong><br />Come experience Mira Road's hottest lounge and dance club - only at Bangtan Lounge.
                </p>
                <div className="about-content3 mt-30">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-md-12">
                      <div className="slider-btn">
                        <a href="#" className="btn ss-btn smoth-scroll">Explore More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Facilities Area */}
      <section id="service-details2" className="pt-70 pb-70 p-relative bg-dark" style={{backgroundImage: 'url(/images/bg-2.jpg)', backgroundSize: 'cover'}}>
        <div className="animations-01"><img src="/img/bg/an-img-01.png" alt="an-img-01" /></div>
        <div className="container">
          <div className="row align-items-center mb-60">
            <div className="col-lg-12">
              <div className="section-title center-align text-center">
                <h5 style={{color: '#d4af37', fontSize: '1.1rem', fontWeight: '600', marginBottom: '10px'}}>EXPLORE OUR SPACES</h5>
                <h2 style={{fontSize: '3.2rem', fontWeight: '800', color: '#fff', marginBottom: '15px', textShadow: '0 2px 10px rgba(212, 175, 55, 0.3)'}}>Bangtan Lounge Facilities</h2>
                <p style={{fontSize: '1.05rem', color: '#ccc', maxWidth: '600px', margin: '0 auto'}}>Experience world-class amenities designed for unforgettable moments</p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {[
              { name: 'Bar', emoji: '🍸', desc: 'Premium spirits, craft cocktails, and world-class mixology. Experience our curated collection of international and local beverages.' },
              { name: 'Lounge', emoji: '🛋️', desc: 'Luxurious seating, ambient lighting, and sophisticated ambiance. Perfect for relaxing with friends and family.' },
              { name: 'Club', emoji: '🎵', desc: 'State-of-the-art sound systems, electrifying DJ booths, and immersive lighting. Dance the night away!' },
              { name: 'Events', emoji: '🎉', desc: 'Corporate events, product launches, and special occasions. We handle every detail for your perfect event.' },
              { name: 'Party', emoji: '🎊', desc: 'Birthday bashes, celebrations, and unforgettable nights. Create memories that last a lifetime.' },
              { name: 'Restaurant', emoji: '🍽️', desc: 'Global cuisine, fine dining, and culinary excellence. Savor flavors from around the world.' }
            ].map((facility, idx) => (
              <div key={idx} className="col-lg-4 col-md-6 mb-30">
                <div style={{
                  backgroundImage: `url(/images/bg-img/${facility.name.toLowerCase()}.jpg)`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  position: 'relative',
                  height: '420px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 32px rgba(212, 175, 55, 0.15)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(212, 175, 55, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(212, 175, 55, 0.15)';
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(212, 175, 55, 0.2) 100%)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    padding: '30px',
                    zIndex: 2
                  }}>
                    <div style={{fontSize: '2.5rem', marginBottom: '15px'}}>{facility.emoji}</div>
                    <h3 style={{fontSize: '2rem', fontWeight: '700', color: '#fff', marginBottom: '12px'}}>{facility.name}</h3>
                    <p style={{fontSize: '0.95rem', color: '#e0e0e0', lineHeight: '1.6', marginBottom: '20px'}}>{facility.desc}</p>
                    <div style={{display: 'flex', gap: '10px'}}>
                      <button 
                        onClick={() => openBookingModal(facility.name)}
                        style={{
                          flex: 1,
                          padding: '10px 16px',
                          background: 'linear-gradient(135deg, #d4af37 0%, #e6c547 100%)',
                          color: '#000',
                          border: 'none',
                          borderRadius: '6px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          fontSize: '0.9rem',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                        }}
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Area */}
      <section id="services" className="services-area pt-70 pb-70 bg-dark" style={{backgroundImage: 'url(/images/bg-1.jpg)', backgroundSize: 'cover'}}>
        <div className="container">
          <div className="row justify-content-center mb-50">
            <div className="col-xl-12">
              <div className="section-title center-align text-center">
                <h5 style={{color: '#d4af37', fontSize: '1.1rem', fontWeight: '600', marginBottom: '10px'}}>OUR MOMENTS</h5>
                <h2 style={{fontSize: '3.2rem', fontWeight: '800', color: '#fff', marginBottom: '15px', textShadow: '0 2px 10px rgba(212, 175, 55, 0.3)'}}>Gallery</h2>
                <p style={{fontSize: '1.05rem', color: '#ccc', maxWidth: '600px', margin: '0 auto'}}>Experience the vibrant moments and unforgettable celebrations at Bangtan Lounge</p>
              </div>
            </div>
          </div>
          <GallerySlider />
        </div>
      </section>


      <BookingModal 
        isOpen={bookingModal.isOpen} 
        facilityType={bookingModal.facilityType}
        onClose={closeBookingModal}
      />
    </main>
  );
};

export default Home;